// extracted by mini-css-extract-plugin
export var banner = "_ra-0";
export var settingRow = "_ra-2";
export var titleIcon = "_ra-1";